/*
 * PhoneAuthenticatorSection Messages
 *
 * This contains all the text for the PhoneAuthenticatorSection component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.PhoneAuthenticatorSection";

export default defineMessages(scope, {
  header:
    "Enter your phone number to receive a verification code via SMS. Carrier messaging charges may apply.",
  us: "United States",
  can: "Canada",
  uk: "United Kingdom",
  ind: "India",
  submitButton: "Receive an SMS code",
  cancel: "Cancel",
  apiError: "Something went wrong. Please try again.",
  requiredPhoneNumber: "Phone number is required",
  invalidPhoneNumber: "Enter a valid phone number",
});
